import { render } from "./conexiones.vue?vue&type=template&id=89a4a31e"
import script from "./conexiones.vue?vue&type=script&lang=js"
export * from "./conexiones.vue?vue&type=script&lang=js"

import "./conexiones.vue?vue&type=style&index=0&id=89a4a31e&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__